import { Box } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useHideFilterDrawer } from "../pages/AppLayout";
import { TOP_BAR_HEIGHT } from "./AppLayout";
import { DeepChatSocketContext } from "../contexts/DeepChatSocketContext";
import { useDeepChatStore } from "../store/home/useDeepchatStore";
import { useSearchStore } from "../store/useSearchStore";
import { useFilterContext } from "../contexts/FilterProvider";
import { updateJoinIdFilter } from "../components/filters/FilterFunctions";
import { useTheme } from "@mui/material/styles";
import { useAtom } from "jotai";
import { getSidebarWidth } from "../components/Deepchat/ChatSidebar";
import ChatSidebar from "../components/Deepchat/ChatSidebar";
import SidebarFilterContent from "../components/Deepchat/SidebarFilterContent";
import { SidebarActivePanelAtom, SidebarDrawerExpandedAtom } from "../components/Deepchat/state/DeepchatState";
import { SIDEBAR_STATE } from "../constants/sidebarEnums";

export default function DeepchatPage() {
  const { filterState, applyFilters, resetFilters } = useFilterContext();
  // HACK: Clear join_ids if they are set upon initial page load
  useEffect(() => {
    if (filterState && filterState.join_ids) {
      applyFilters(updateJoinIdFilter(filterState, []));
    }
  }, []);

  const { applyDefaultSearchState } = useSearchStore();
  applyDefaultSearchState();

  const { hideFilterDrawer, setHideFilterDrawer } = useHideFilterDrawer();
  const [drawerExpanded, setDrawerExpanded] = useAtom(SidebarDrawerExpandedAtom);

  // On mount, show the hamburger (collapsed state)
  useEffect(() => {
    setHideFilterDrawer(true);
  }, []);

  const [activePanel, setActivePanel] = useAtom(SidebarActivePanelAtom);

  // Sync TopBar hamburger toggle → drawer expanded atom
  // Clicking the chevron (hideFilterDrawer → true) resets everything to the default rail state
  useEffect(() => {
    if (hideFilterDrawer === false) {
      setActivePanel(SIDEBAR_STATE.CLOSED);
      setDrawerExpanded(true);
    } else if (hideFilterDrawer === true) {
      setActivePanel(SIDEBAR_STATE.CLOSED);
      setDrawerExpanded(false);
    }
  }, [hideFilterDrawer]);

  const { disableFilters, lastJsonMessage, sendJsonMessage, readyState } = useDeepChatStore();
  const panelOpen = activePanel !== SIDEBAR_STATE.CLOSED;
  const sidebarWidth = getSidebarWidth(drawerExpanded, panelOpen);

  const theme = useTheme();
  const marginTransition = `margin ${theme.transitions.duration.enteringScreen}ms`;

  const location = useLocation();
  const isSummarizePage = location.pathname === "/deepchat/summarize";

  return (
    <>
      <ChatSidebar
        open={true}
        // Filters are not applicable to summarization, so hide them on that page.
        filterContent={isSummarizePage ? undefined : <SidebarFilterContent disabled={disableFilters} />}
        showDocuments={isSummarizePage}
        // Starting a new chat should clear any filters carried over from a thread.
        onNewChat={resetFilters}
      />
      <Box
        component="main"
        sx={{
          marginLeft: `${sidebarWidth}px`,
          transition: marginTransition,
          flexGrow: 1,
          paddingTop: `${TOP_BAR_HEIGHT}px`,
          minHeight: "100vh",
        }}
      >
        <div style={{ padding: "24px", display: "flex", justifyContent: "center", height: "100%", width: "100%" }}>
          <DeepChatSocketContext.Provider value={{ lastJsonMessage, sendJsonMessage, readyState }}>
            <Outlet context={useHideFilterDrawer()} />
          </DeepChatSocketContext.Provider>
        </div>
      </Box>
    </>
  );
}
